import { render, staticRenderFns } from "./PageContainerHeader.vue?vue&type=template&id=427d3c8e&scoped=true&"
import script from "./PageContainerHeader.vue?vue&type=script&lang=ts&"
export * from "./PageContainerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PageContainerHeader.vue?vue&type=style&index=0&id=427d3c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d3c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
